const { io } = require("socket.io-client");

const socket = io(process.env.REACT_APP_API_URL_FOR_SOCKET);
export default socket;